import React, { useCallback } from 'react';

import { Tooltip } from '@material-ui/core';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import useClassNames from '~/hooks/use-classnames';
import { SUBSCRIPTION_STATUS, SIGNATURE_STATUS } from '~/values/enums';

import styles from './SubscriptionStatusTag.module.scss';

const SubscriptionStatusTag = ({ user }) => {
    const subscription = user?.cliente?.assinatura;
    const situation = subscription?.situacao;
    const subscriptionContainerClassNames = useClassNames([
        styles.tag,
        { [styles.alertContainer]: situation === SIGNATURE_STATUS.PENDENTE },
        { [styles.successContainer]: situation === SIGNATURE_STATUS.VIGENTE },
    ]);

    const renderSituationLabel = useCallback(() => {
        if (situation === SIGNATURE_STATUS.VIGENTE) {
            return `Assinatura ${subscription.plano_assinatura.nome}`;
        }

        return SUBSCRIPTION_STATUS.getLabelByKey(situation || 'SEM_ASSINATURA');
    }, [situation, subscription]);

    return (
        <Tooltip title="Clique para ver os dados de assinatura">
            <Link to="/app/assinatura">
                <div
                    className={subscriptionContainerClassNames}
                >
                    {renderSituationLabel()}
                </div>
            </Link>
        </Tooltip>
    );
};

const mapStateToProps = ({ user }) => {
    return {
        user,
    };
};

export default connect(mapStateToProps)(SubscriptionStatusTag);
